import { createElement, Fragment } from "react";
/**
 * Internal Dependencies
 */
import useProgressPerecent from '../../hooks/use-progress-percent';
const ProgressMergeTag = ({
  modifier
}) => {
  const percent = useProgressPerecent();
  if (modifier === 'percent') {
    return createElement(Fragment, null, percent);
  }
  return null;
};
export default ProgressMergeTag;
//# sourceMappingURL=progress.js.map